import { useAtom } from 'jotai';
import { isSettingsPanelOpenAtom } from '@/atoms/sidebar';
import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import useGetLinkPath from '@/hooks/useGetLinkPath';
import { displaySettingsLinkAtom } from '@/atoms/navigation';

export const SettingsButton = () => {
  const { t } = useTranslation('visualisation');
  const [isSettingsPanelOpen, setIsSettingsPanelOpen] = useAtom(isSettingsPanelOpenAtom);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { to, relative } = useGetLinkPath(displaySettingsLinkAtom);

  const handleClick = () => {
    // When the button is clicked from a video preview page, we want to make sure the settings panel opens
    setIsSettingsPanelOpen(pathname.includes('video/preview') || !isSettingsPanelOpen);
    navigate(to, { relative });
  };

  return (
    <span data-testid="settings-button">
      <ButtonIcon icon="DisplaySettings" title={t('displaySettings')} onClick={handleClick} variant="ghost" />
    </span>
  );
};
